import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class CarouselPartnerItem extends Component {
    constructor(props) {
        super(props);
    }

    handleClick = (e) => {
       if (e.currentTarget.attributes.href.nodeValue === '#') {
           e.preventDefault();
       }
    }

    setPartnerName = (e) => {
        e.target.style.display = 'none';
        e.target.nextElementSibling.classList.add('show');
     }

    render() {
        let websiteLink = '';
        let target = '';
        let rel = '';
        const isHtts = this.props.data.websiteLink.indexOf('http');
        if (isHtts === -1 && this.props.data.isActive) {
            websiteLink = 'https://' + this.props.data.websiteLink;
            target = '_blank';
            rel = 'noreferrer';
        } else if (this.props.data.isActive) {
            websiteLink = this.props.data.websiteLink;
            target = '_blank';
            rel = 'noreferrer';
        } else if (!this.props.data.isActive) {
            websiteLink = '#'
        }
        return(
            <span className={`${this.props.data.isActive ? '' : 'disabled'} carousel-item`}>
                <a href={websiteLink} target={target} rel={rel} onClick={this.handleClick}>
                    <span className='partner-item'>
                        <img onError={this.setPartnerName} referrerPolicy="no-referrer"
                             src={`/api/welsend/public/partners/${this.props.data.id}/logo`}
                        className="partner-logo"/>
                        <span className="parnterName">{this.props.data.name}</span>
                    </span>
                 </a>
                <span className="not-available">{translateStaticContent('partnersWarningMessage', 
                                            this.props.defaultStaticContentPartners, 
                                            this.props.activeLangStaticContentPartners)}</span>
            </span>          
        )
    }
    
}

export default CarouselPartnerItem;

CarouselPartnerItem.propTypes = {
    data: PropTypes.shape({
        websiteLink: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
    }),
    defaultStaticContentPartners: PropTypes.object,
    activeLangStaticContentPartners: PropTypes.object,
}